import { template as template_f87d6e68bc8149bf8b4406e8ba139c96 } from "@ember/template-compiler";
import { on } from '@ember/modifier';
import Component from '@glimmer/component';
import SpdsGhostButton from 'ember-simplepractice/components/spds/action/button/ghost';
import SpdsLinkButton from 'ember-simplepractice/components/spds/action/button/link';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import t from 'ember-intl/helpers/t';
export default class RequestClinicianSearchMobileFiltersTopBar extends Component {
    get variant() {
        return this.args.variant === 'detail' ? 'detail' : 'main';
    }
    static{
        template_f87d6e68bc8149bf8b4406e8ba139c96(`
    <div class="mobile-filters-top-bar">
      <SpdsGhostButton
        class="mobile-filters-back-button"
        data-test-clinician-search-mobile-filters-back={{this.variant}}
        {{on "click" @onBack}}
      >
        <span class="mobile-filters-back-chevron" aria-hidden="true">
          {{svgJar "chevron-left"}}
        </span>
        {{t "booking.clinicianSearch.mobileFilters.back"}}
      </SpdsGhostButton>
      <SpdsLinkButton
        @text={{t "booking.clinicianSearch.mobileFilters.clearFilters"}}
        class="mobile-filters-clear-link"
        data-test-clinician-search-mobile-filters-clear={{this.variant}}
        {{on "click" @onClear}}
      />
    </div>
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
